<template>
  <div class="global-search align-items-center position-relative">
    <input
      v-model="userInput"
      type="search"
      ref='searchBoxInput'
      class="global-search__input"
      @keyup.enter="search()"
      :placeholder="I18n.t('search_page.search.placeholder')"
    >
    <button
      type="button"
      class="search__clear-input"
      v-if="userInput"
      @mousedown.prevent
      @click="clearSearch"
    >
      <span class="icon-close-big"></span>
    </button>
    <div class="global-search__actions">
      <div class="global-search__scope-select d-none d-lg-block">
        <span class="icon icon-arrow-bottom"/>
        <select
          class="form-control"
          @change="changeActiveTab()"
          v-model="searchScope"
        >
          <option value="artworks">
            {{ I18n.t('search_page.search.select.options.artworks') }}
          </option>
          <option value="incomingArtworks">
            {{ I18n.t('search_page.search.select.options.incoming_auctions') }}
          </option>
        </select>
      </div>
      <button
        type="submit"
        class="btn-oval btn-oval--orange"
        @click="search()"
      >
        <a><span class="icon icon-search"></span></a>
      </button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { DEFAULT_SEARCH_SCOPE, SCOPES,
    ARTWORKS_FILTERS } from '../consts';
  import { UPDATE_ACTIVE_TAB } from '../store/mutation-types';

  export default {
    name: 'GlobalSearch',
    data() {
      return {
        userInput: this.$route.query.main_query || '',
        searchScope: this.$route.query.scope || DEFAULT_SEARCH_SCOPE,
        artworksScope: SCOPES.ARTWORKS,
        statesPath: ARTWORKS_FILTERS.STATES.PATH,
        incomingArtworksScope: SCOPES.INCOMING_ARTWORKS,
      };
    },
    computed: {
      ...mapGetters(['activeTab', 'mainQueryValue']),
      mainQuery() {
        return this.$route.query.main_query || '';
      },
    },
    watch: {
      mainQueryValue() {
        this.userInput = this.mainQueryValue;
      },
      activeTab() {
        this.searchScope = this.activeTab;
        this.getResources();
      },
    },
    methods: {
      ...mapActions(['getArtworksWhenMainQueryIsChanging',
        'getArtworksWhenMainQueryIsClearing',
        'getIncomingArtworksWhenMainQueryIsChanging']),
      clearSearch() {
        this.userInput = '';
        this.search();
      },
      search() {
        if (this.userInput !== this.mainQuery) {
          if (this.userInput.length === 0) {
            this.getArtworksWhenMainQueryIsClearing({ value: this.userInput });
          } else {
            this.getResources();
          }
        }
      },
      getResources() {
        switch (this.activeTab) {
          case this.artworksScope:
            this.getArtworksWhenMainQueryIsChanging({ value: this.userInput });
            break;
          case this.incomingArtworksScope:
            this.getArtworksWhenMainQueryIsChanging({ value: this.userInput });
            break;
          default:
        }
      },
      changeActiveTab() {
        this.$store.commit(UPDATE_ACTIVE_TAB, { activeTab: this.searchScope });
      },
    },
    mounted() {
      this.$refs.searchBoxInput.focus();
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/search_box.vue?58c087ba